"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PBPTemplate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const resources_1 = require("../resources");
const PBPTemplate = ({ children, onLogoClick }) => {
    return ((0, jsx_runtime_1.jsxs)(Template, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(resources_1.LogoPBPWithText, { onClick: onLogoClick }, void 0) }, void 0), (0, jsx_runtime_1.jsx)("div", { children: children }, void 0)] }, void 0));
};
exports.PBPTemplate = PBPTemplate;
const Template = styled_components_1.default.div `
  height: 100vh;

  & > div:first-of-type {
    background-color: ${({ theme }) => theme.colors.whiteBase};
    height: 86px;
    padding: ${({ theme }) => `${theme.spacings.l} ${theme.spacings.xl}`};

    img {
      cursor: pointer;
      height: 100%;
      width: auto;
    }

    @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
      height: 73px;
      padding: ${({ theme }) => theme.spacings.m};
    }
  }

  & > div:last-of-type {
    background-color: ${({ theme }) => theme.colors.silverLighten40};
    height: calc(100vh - 86px);
    padding: ${({ theme }) => theme.spacings.xl};

    @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
      height: calc(100vh - 73px);
      padding: ${({ theme }) => theme.spacings.m};
    }
  }
`;
//# sourceMappingURL=PBPTemplate.js.map